<script>
  export default {
    props: {
      isTailwind:{
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        windowWidth: 0,
      }
    },
    watch:{
      windowWidth(newValue, oldValue){
        this.$store.dispatch('window/setWidth', newValue)
        // refresh orientation as well
        const orientation = this.resolveOrientation(this.windowWidth, newValue);
        this.$store.dispatch('window/setOrientation', orientation)
      }
    },
    created() {
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      });
      const orientation = this.resolveOrientation(window.innerWidth, window.innerHeight);
      this.$store.dispatch('window/setOrientation', orientation)
    },
    methods: {
      resolveOrientation(width, height){
        if(this.isIos){
          if (width > height){
            return 'landscape-primary'
          }else{
            return 'portrait-primary'
          }
        }else{
          return (screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation
        }
      },
    }
  }
</script>
<template>
  <div class="wrapper">
    <div class="main-container">
      <div
        class="container-fluid"
        :class="{
          'tw-p-u': isTailwind,
        }">
        <div
          :class="{
            'row': !isTailwind,
          }">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
